import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowSize from '../new-service/useWindowSize';
import NotificationBell from '../notifications/NotificationBell';
import LocationPicker from '../multiLocation/LocationPicker';
import { SOCIAL_VISIBLE, MARKETING_HOME_VISIBLE, DISCOUNTS_VISIBLE } from '../../config/featureFlags';
import { goUp, backTarget } from './goUp';
import '../staff/StaffTopNav.css';
import './MarketingTopNav.css';
import '../new-service/CatalogueTopNav.css';

const CampaignIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="m3 11 15-6v14l-15-6v-2Z" /><path d="M11.6 16.8a3 3 0 1 1-5.2-3" /><path d="M18 8a4 4 0 0 1 0 8" />
    </svg>
);

const CommsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);

const SettingsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68 1.65 1.65 0 0 0 10 3.17V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
);

const BackArrowIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
    </svg>
);

// The app's own menu, for Marketing's home on a tablet or phone, where the
// side nav is folded away and Back would have nowhere to go.
const MenuIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
    </svg>
);

const PerformanceIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v16a2 2 0 0 0 2 2h16" />
        <path d="M7 14l4-4 3 3 5-6" />
    </svg>
);

const JourneyIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="5" cy="6" r="2.4" />
        <circle cx="19" cy="18" r="2.4" />
        <path d="M7.4 6H15a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H9a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h7.6" />
    </svg>
);

const SocialIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
    </svg>
);

const DiscountIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z" /><path d="M9.5 14.5l5-5" />
    </svg>
);

const LoyaltyIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />
    </svg>
);

const HomeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="17" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
);

const navItems = [
    ...(MARKETING_HOME_VISIBLE ? [{ id: 'home', label: 'Home', icon: <HomeIcon />, path: '/marketing-home' }] : []),
    ...(MARKETING_HOME_VISIBLE ? [{ id: 'calendar', label: 'Calendar', icon: <CalendarIcon />, path: '/marketing-calendar' }] : []),
    { id: 'campaigns', label: 'Campaigns', icon: <CampaignIcon />, path: '/marketing-campaigns' },
    ...(SOCIAL_VISIBLE ? [{ id: 'social', label: 'Social', icon: <SocialIcon />, path: '/marketing-social' }] : []),
    { id: 'journeys', label: 'Journeys', icon: <JourneyIcon />, path: '/marketing-journeys' },
    { id: 'loyalty', label: 'Loyalty', icon: <LoyaltyIcon />, path: '/marketing-loyalty' },
    ...(DISCOUNTS_VISIBLE ? [{ id: 'discounts', label: 'Discounts', icon: <DiscountIcon />, path: '/marketing-discounts' }] : []),
    { id: 'performance', label: 'Performance', icon: <PerformanceIcon />, path: '/marketing-performance' },
    { id: 'communications', label: 'Communications', icon: <CommsIcon />, path: '/marketing' },
    { id: 'settings', label: 'Config', icon: <SettingsIcon />, path: '/marketing-setting' },
];

const HOME = { path: '/marketing-home', label: 'Marketing' };

/**
 * Marketing's top bar. A section's Back goes up to its parent (the Marketing
 * home, or `parent` for a page below a section, such as Your brand under
 * Config), never forward, so Back can't bounce between two pages. `title`
 * names a page that isn't one of the sections.
 */
function MarketingTopNav({ activeTab, children, history, location, parent = HOME, title: pageTitle }) {
    const { width } = useWindowSize();
    const isMobile = width <= 1100;
    // Seven or more tabs: below 1380px (1500px with Home and Calendar) they
    // drop their icons so Config stays in view
    const showIcons = navItems.length < 7 || !width || width >= (navItems.length > 8 ? 1500 : 1380);
    const current = navItems.find(n => n.id === activeTab);
    const up = () => goUp(history, location, MARKETING_HOME_VISIBLE ? parent.path : '/marketing-nav');
    // Named for where Back really goes: the page that opened this one, when it's a Marketing one
    const target = backTarget(location, parent.path);
    const back = target === parent.path ? parent : (navItems.find(n => n.path === target) || (target === HOME.path ? HOME : parent));
    const backLabel = back.id === 'home' ? 'Marketing' : back.label;

    if (isMobile) {
        const title = pageTitle || (current && current.id !== 'home' ? current.label : 'Marketing');
        const onHome = MARKETING_HOME_VISIBLE && activeTab === 'home';
        return (
            <div className="catalogue-mobile-header">
                {onHome ? (
                    // The home is one of the app's own places: its menu, as on the Bailey tab.
                    <button type="button" className="catalogue-mobile-back-btn" onClick={() => document.body.classList.toggle('nav_menu_open')} aria-label="Menu">
                        <MenuIcon />
                    </button>
                ) : (
                    <button type="button" className="catalogue-mobile-back-btn" onClick={up} aria-label={`Back to ${MARKETING_HOME_VISIBLE ? backLabel : 'Marketing'}`}>
                        <BackArrowIcon />
                    </button>
                )}
                <h1 className="catalogue-mobile-title">{title}</h1>
                <div className="catalogue-mobile-actions">
                    <LocationPicker slot="mobile" />
                    {children}
                </div>
            </div>
        );
    }

    // With the Marketing home, Marketing works like Catalogue: the home is
    // the menu (no tab strip), and each section gets a slim bar back to it
    // with its title, its actions and the bell
    if (MARKETING_HOME_VISIBLE) {
        const onHome = activeTab === 'home';
        return (
            <div className={`catalogue-top-nav catalogue-topbar${onHome ? ' catalogue-topbar--hub' : ''}`}>
                <div className="catalogue-top-nav-container">
                    <div className="catalogue-top-nav-content">
                        {!onHome && (
                            <>
                                <button
                                    type="button"
                                    className="catalogue-tab-btn catalogue-tab-back"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={up}
                                    aria-label={`Back to ${backLabel}`}
                                >
                                    <BackArrowIcon />
                                    <span>{backLabel}</span>
                                </button>
                                <h2 className="catalogue-topbar-title">{pageTitle || (current ? current.label : 'Marketing')}</h2>
                            </>
                        )}
                        <div className="catalogue-nav-actions">
                            {children}
                        </div>
                    </div>
                </div>
                <div className="notif-bell-pinned-wrap">
                    <LocationPicker />
                    <NotificationBell />
                </div>
            </div>
        );
    }

    return (
        <div className="catalogue-top-nav">
            <div className="catalogue-top-nav-container">
                <div className="catalogue-top-nav-content">
                    <nav className={`catalogue-tabs-nav${navItems.length > 8 ? ' mk-dense' : ''}`}>
                        {navItems.map(item => (
                            <button
                                key={item.id}
                                className={`catalogue-tab-btn${activeTab === item.id ? ' active' : ''}`}
                                onClick={() => history.push(item.path)}
                            >
                                {showIcons && item.icon}
                                <span>{item.label}</span>
                            </button>
                        ))}
                    </nav>
                    <div className="catalogue-nav-actions">
                        {children}
                    </div>
                </div>
            </div>
            <div className="notif-bell-pinned-wrap">
                <LocationPicker />
                <NotificationBell />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(MarketingTopNav));
